module.exports = __webpack_public_path__ + "img/2022_chrysler_300.58645261.png";